import React, { useState, useEffect, useMemo } from 'react';
import { getSymbols } from '../../services/SymbolsService';
import Select from 'react-select';
import logger from '../../utils/logger';

/**
 * props:
 * - symbol
 * - disabled
 * - onChange
 */
function SelectSymbol(props) {

    const [symbols, setSymbols] = useState(["LOADING"]);
    const [isDisabled, setIsDisabled] = useState(false);
    const [value, setValue] = useState('');

    useEffect(() => {
        setValue({ label: props.symbol, value: props.symbol });
    }, [props.symbol])

    useEffect(() => {
        setIsDisabled(props.disabled);
    }, [props.disabled])

    useEffect(() => {
        getSymbols()
            .then(symbolObjects => {
                const symbolNames = symbolObjects.rows ? symbolObjects.rows.map(s => s.symbol) : symbolObjects.map(s => s.symbol);

                if (symbolNames.length){
                    setSymbols(symbolNames.map(s => {
                        return {
                            value: s, label: s
                        }
                    }));
                }
                else {
                    setSymbols(["NO SYMBOLS"]);
                    setIsDisabled(true);
                }
            })
            .catch(err => {
                logger.error(err.response ? err.response.data : err.message);
                setSymbols(["ERROR"]);
                setIsDisabled(true);
            })
    }, [])

    function onSymbolChange(event) {
        props.onChange({ target: { id: 'symbol', value: event.value } });
    }

    // Dark theme styles — inline (highest priority; survives production emotion class hashing)
    const customStyles = {
        // 220px as before, but shrinkable: maxWidth 100% lets the flex header squeeze
        // the control on a narrow phone instead of pushing the page sideways.
        // (A bare width:100% would collapse it to ~136px in the shrink-to-fit toolbar
        // and cramp the dropdown menu, which inherits the control's width.)
        control: (base, state) => ({ ...base, width: 220, minWidth: 130, maxWidth: '100%', backgroundColor: '#1c222e', borderColor: state.isFocused ? '#f5c451' : '#2a3240', boxShadow: 'none', color: '#e6e9ef', ':hover': { borderColor: '#3a4658' } }),
        menu: (base) => ({ ...base, backgroundColor: '#1c222e', border: '1px solid #2a3240', zIndex: 9999 }),
        menuList: (base) => ({ ...base, backgroundColor: '#1c222e' }),
        option: (base, state) => ({ ...base, backgroundColor: state.isSelected ? 'rgba(245,196,81,0.22)' : state.isFocused ? 'rgba(245,196,81,0.14)' : 'transparent', color: state.isFocused || state.isSelected ? '#f5c451' : '#e6e9ef', cursor: 'pointer' }),
        singleValue: (base) => ({ ...base, color: '#e6e9ef' }),
        input: (base) => ({ ...base, color: '#e6e9ef' }),
        placeholder: (base) => ({ ...base, color: '#6c7689' }),
        indicatorSeparator: (base) => ({ ...base, backgroundColor: '#2a3240' }),
        dropdownIndicator: (base) => ({ ...base, color: '#97a1b2' }),
        noOptionsMessage: (base) => ({ ...base, color: '#97a1b2' }),
    }

    const selectTheme = (theme) => ({ ...theme, colors: { ...theme.colors, primary: '#f5c451', primary25: 'rgba(245,196,81,0.14)', primary50: 'rgba(245,196,81,0.20)', neutral0: '#1c222e', neutral80: '#e6e9ef' } })

    const selectSymbol = useMemo(() => {
        return (
            <Select
                value={value}
                isDisabled={isDisabled}
                styles={customStyles}
                theme={selectTheme}
                classNamePrefix="ghsel"
                onChange={onSymbolChange}
                options={symbols} />
        )
    }, [symbols, value, isDisabled])

    return (selectSymbol);
}

export default SelectSymbol;